/* ═══════════════════════════════════════════════════════════
   Hayah Al-Muslimah — Custom Header JS
   Shopify Impulse Theme 7.x
   File: assets/header-hayah.js
   Vanilla JS — no jQuery dependency
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  console.log('[HH Header] Script loaded ✓');

  /* window.hhHeader is set inline by sections/header.liquid */
  const cfg = window.hhHeader || {};
  const routes = cfg.routes || {};

  /* ══════════════════════════════════════════════════════
     UTILITY HELPERS
     ══════════════════════════════════════════════════════ */

  function $(id) { return document.getElementById(id); }

  function formatMoney(cents) {
    const symbol = (cfg.currency && cfg.currency.symbol) || '£';
    return symbol + (cents / 100).toFixed(2);
  }

  function debounce(fn, delay) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  /* ══════════════════════════════════════════════════════
     TYPEWRITER PLACEHOLDER
     ══════════════════════════════════════════════════════ */
  function initTypewriter() {
    const typedTextEl = $('hh-typed-text');
    const typedPh     = $('hh-typed-ph');
    const searchInput = $('hh-search-input');
    if (!typedTextEl || !searchInput) return;

    // Placeholders come from theme settings via window.hhHeader.placeholders
    const raw = cfg.placeholders || '';
    const phrases = raw.split('||').map(s => s.trim()).filter(Boolean);
    if (phrases.length === 0) return;

    let phIdx = 0, charIdx = 0, deleting = false, timer = null;

    function step() {
      if (searchInput.value.trim() !== '') return; // pause if user typing
      const phrase = phrases[phIdx];
      if (deleting) {
        charIdx--;
        typedTextEl.textContent = phrase.slice(0, charIdx);
      } else {
        charIdx++;
        typedTextEl.textContent = phrase.slice(0, charIdx);
      }
      let delay = deleting ? 38 : 68;
      if (!deleting && charIdx === phrase.length) { delay = 2200; deleting = true; }
      else if (deleting && charIdx === 0) {
        deleting = false;
        phIdx = (phIdx + 1) % phrases.length;
        delay = 340;
      }
      timer = setTimeout(step, delay);
    }
    step();

    // Pause when focused, resume when blurred empty
    searchInput.addEventListener('focus', () => {
      if (typedPh) typedPh.style.opacity = '0';
      clearTimeout(timer);
    });
    searchInput.addEventListener('blur', () => {
      if (searchInput.value.trim() === '') {
        if (typedPh) typedPh.style.opacity = '1';
        typedTextEl.textContent = '';
        charIdx = 0; deleting = false;
        step();
      }
    });
    searchInput.addEventListener('input', () => {
      if (typedPh) typedPh.style.opacity = searchInput.value ? '0' : '1';
    });
  }

  /* ══════════════════════════════════════════════════════
     RECENT SEARCHES (localStorage)
     ══════════════════════════════════════════════════════ */
  const RECENT_KEY = 'hh_recent_searches';
  const RECENT_MAX = 5;

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveRecent(term) {
    let list = getRecent().filter(t => t.toLowerCase() !== term.toLowerCase());
    list.unshift(term);
    list = list.slice(0, RECENT_MAX);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function removeRecent(term) {
    const list = getRecent().filter(t => t !== term);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function clearRecent() {
    try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
  }

  function buildRecentItem(term) {
    const li = document.createElement('li');
    li.innerHTML = `
      <div class="hh-sd__recent" role="option">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 15"/>
        </svg>
        <span class="hh-sd__recent-text">${term}</span>
        <button class="hh-sd__recent-remove" aria-label="Remove ${term}">×</button>
      </div>`;
    li.querySelector('.hh-sd__recent').addEventListener('click', (e) => {
      if (e.target.closest('.hh-sd__recent-remove')) return;
      const inp = $('hh-search-input');
      if (inp) { inp.value = term; inp.dispatchEvent(new Event('input', { bubbles: true })); }
    });
    li.querySelector('.hh-sd__recent-remove').addEventListener('click', (e) => {
      e.stopPropagation();
      removeRecent(term);
      li.remove();
      checkRecentEmpty($('hh-recent-list'), $('hh-dd-recent'));
    });
    return li;
  }

  function renderRecentList(listId, wrapId) {
    const listEl = $(listId);
    if (!listEl) return;
    const items = getRecent();
    listEl.innerHTML = '';
    if (items.length === 0) {
      checkRecentEmpty(listEl, $(wrapId));
      return;
    }
    items.forEach(t => listEl.appendChild(buildRecentItem(t)));
  }

  function checkRecentEmpty(listEl, wrapEl) {
    if (!listEl || !wrapEl) return;
    if (listEl.children.length === 0) {
      listEl.innerHTML = '<li style="padding:14px 15px;font-size:13px;color:#888;">No recent searches</li>';
    }
  }

  /* ══════════════════════════════════════════════════════
     PREDICTIVE SEARCH
     ══════════════════════════════════════════════════════ */
  async function fetchProducts(q) {
    const url = `${routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4&resources[fields]=title,variants.sku,vendor,product_type`;
    try {
      const r = await fetch(url);
      const data = await r.json();
      return (data.resources && data.resources.results && data.resources.results.products) || [];
    } catch (e) { return []; }
  }

  function buildResultItem(product, searchTerm) {
    // Predictive search API returns price as a decimal string (e.g. "48.00"), NOT pence
    const symbol = (cfg.currency && cfg.currency.symbol) || '£';
    const price  = product.price !== undefined
      ? symbol + parseFloat(product.price).toFixed(2)
      : '';
    const imgSrc = product.featured_image ? product.featured_image.url + '&width=100' : null;
    const imgHtml = imgSrc
      ? `<img src="${imgSrc}" alt="${product.title}" class="hh-sd__result-img" loading="lazy">`
      : '<div class="hh-sd__result-img hh-sd__result-img--empty"></div>';
    const sku = product.variants && product.variants[0] && product.variants[0].sku
      ? `<span class="hh-sd__result-sku">SKU: ${product.variants[0].sku}</span>` : '';

    const li = document.createElement('li');
    li.innerHTML = `
      <a href="${product.url}" class="hh-sd__result">
        ${imgHtml}
        <div class="hh-sd__result-info">
          <span class="hh-sd__result-title">${product.title}</span>
          ${sku}
        </div>
        ${price ? `<span class="hh-sd__result-price">${price}</span>` : ''}
      </a>`;
    // Save the search term to recent history when the user clicks a result
    if (searchTerm) {
      li.querySelector('a').addEventListener('click', () => saveRecent(searchTerm));
    }
    return li;
  }

  async function runSearch(q, opts) {
    const { recentWrapId, resultsWrapId, resultsListId, viewAllId } = opts;
    const recentWrap  = $(recentWrapId);
    const resultsWrap = $(resultsWrapId);
    const resultsList = $(resultsListId);
    const viewAll     = $(viewAllId);

    if (!q.trim()) {
      if (recentWrap)  recentWrap.hidden  = false;
      if (resultsWrap) resultsWrap.hidden = true;
      return;
    }

    if (recentWrap)  recentWrap.hidden  = true;
    if (resultsWrap) resultsWrap.hidden = false;
    if (resultsList) resultsList.innerHTML = '<li style="padding:10px 15px;font-size:13px;color:#888;">Searching…</li>';

    const products = await fetchProducts(q);
    if (!resultsList) return;

    if (products.length === 0) {
      resultsList.innerHTML = '<li class="hh-sd__no-results">No products found</li>';
    } else {
      resultsList.innerHTML = '';
      products.forEach(p => resultsList.appendChild(buildResultItem(p, q)));
    }

    if (viewAll) {
      viewAll.href = `${routes.search}?type=product&q=${encodeURIComponent(q)}`;
      viewAll.innerHTML = `See all results for "<strong>${q}</strong>"`;
    }
  }

  /* ══════════════════════════════════════════════════════
     DESKTOP SEARCH
     ══════════════════════════════════════════════════════ */
  function initDesktopSearch() {
    const input    = $('hh-search-input');
    const dropdown = $('hh-search-dd');
    const clearBtn = $('hh-search-clear');
    const clearAll = $('hh-clear-all-recent');
    if (!input || !dropdown) return;

    const debouncedSearch = debounce((q) => {
      runSearch(q, {
        recentWrapId:  'hh-dd-recent',
        resultsWrapId: 'hh-dd-results',
        resultsListId: 'hh-results-list',
        viewAllId:     'hh-sd-view-all'
      });
    }, 280);

    input.addEventListener('focus', () => {
      // Re-render on every open so newly saved searches always appear
      renderRecentList('hh-recent-list', 'hh-dd-recent');
      // If input already has text, show results panel; otherwise show recents
      if (input.value.trim()) {
        debouncedSearch(input.value.trim());
      } else {
        const recentWrap  = $('hh-dd-recent');
        const resultsWrap = $('hh-dd-results');
        if (recentWrap)  recentWrap.hidden  = false;
        if (resultsWrap) resultsWrap.hidden = true;
      }
      dropdown.hidden = false;
      dropdown.removeAttribute('hidden');
    });

    input.addEventListener('blur', () => {
      setTimeout(() => { dropdown.hidden = true; }, 200);
    });

    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      debouncedSearch(q);
    });

    // Save on Enter keydown — fires synchronously before the page navigates,
    // which is more reliable than the form submit event.
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const q = input.value.trim();
        if (q) saveRecent(q);
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        clearBtn.hidden = true;
        renderRecentList('hh-recent-list', 'hh-dd-recent');
        const recentWrap  = $('hh-dd-recent');
        const resultsWrap = $('hh-dd-results');
        if (recentWrap)  recentWrap.hidden  = false;
        if (resultsWrap) resultsWrap.hidden = true;
        input.focus();
      });
    }

    if (clearAll) {
      clearAll.addEventListener('click', () => {
        clearRecent();
        renderRecentList('hh-recent-list', 'hh-dd-recent');
      });
    }

    // Save on form submit
    const form = input.closest('form');
    if (form) {
      form.addEventListener('submit', () => {
        const q = input.value.trim();
        if (q) saveRecent(q);
      });
    }
  }

  /* ══════════════════════════════════════════════════════
     MOBILE HEADER SEARCH (expands below bar)
     ══════════════════════════════════════════════════════ */
  function initMobileSearch() {
    const openBtn   = $('hh-mob-search-btn');
    const closeBtn  = $('hh-mob-search-close');
    const searchBar = $('hh-mob-search');
    const input     = $('hh-mob-search-input');
    const clearAll  = $('hh-mob-clear-all');
    if (!openBtn || !searchBar) return;

    renderRecentList('hh-mob-recent-list', 'hh-mob-recent-wrap');

    openBtn.addEventListener('click', () => {
      searchBar.classList.add('hh-mob-search--open');
      searchBar.removeAttribute('hidden');
      openBtn.setAttribute('aria-expanded', 'true');
      setTimeout(() => input && input.focus(), 150);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        searchBar.classList.remove('hh-mob-search--open');
        openBtn.setAttribute('aria-expanded', 'false');
        if (input) {
          input.value = '';
          input.dispatchEvent(new Event('input'));
        }
      });
    }

    if (input) {
      const debouncedSearch = debounce((q) => {
        runSearch(q, {
          recentWrapId:  'hh-mob-recent-wrap',
          resultsWrapId: 'hh-mob-results-wrap',
          resultsListId: 'hh-mob-results-list',
          viewAllId:     'hh-mob-view-all'
        });
      }, 280);
      input.addEventListener('input', () => debouncedSearch(input.value.trim()));
    }

    if (clearAll) {
      clearAll.addEventListener('click', () => {
        clearRecent();
        renderRecentList('hh-mob-recent-list', 'hh-mob-recent-wrap');
      });
    }
  }

  /* ══════════════════════════════════════════════════════
     MOBILE MENU DRAWER
     ══════════════════════════════════════════════════════ */
  function initMobileMenuDrawer() {
    const openBtn  = $('hh-mob-menu-btn');
    const closeBtn = $('hh-mob-drawer-close');
    const overlay  = $('hh-mob-menu-overlay');
    const drawer   = $('hh-mob-drawer');
    if (!drawer) return;

    function open() {
      drawer.classList.add('hh-mob-drawer--open');
      if (overlay) overlay.classList.add('hh-overlay--open');
      drawer.removeAttribute('aria-hidden');
      if (overlay) overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('hh-mob-drawer--open');
      if (overlay) overlay.classList.remove('hh-overlay--open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (openBtn)  openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);

    // Accordion nav items — clicking the whole row expands/collapses the submenu.
    drawer.querySelectorAll('.hh-mob-nav__btn').forEach(btn => {
      if (!btn.nextElementSibling) return; // no submenu, skip
      btn.addEventListener('click', () => {
        const item       = btn.closest('.hh-mob-nav__item');
        const isExpanded = item.classList.contains('hh-mob-nav__item--expanded');
        item.classList.toggle('hh-mob-nav__item--expanded', !isExpanded);
        btn.setAttribute('aria-expanded', String(!isExpanded));
      });
    });

    // Drawer search
    const drawerInput   = $('hh-mob-drawer-search');
    const drawerResults = $('hh-mob-drawer-results');
    if (drawerInput && drawerResults) {
      const debouncedSearch = debounce(async (q) => {
        if (!q) { drawerResults.hidden = true; return; }
        drawerResults.hidden = false;
        const listEl  = $('hh-mob-drawer-results-list');
        const viewAll = $('hh-mob-drawer-view-all');
        const products = await fetchProducts(q);
        if (!listEl) return;
        if (products.length === 0) {
          listEl.innerHTML = '<li class="hh-sd__no-results">No products found</li>';
        } else {
          listEl.innerHTML = '';
          products.forEach(p => listEl.appendChild(buildResultItem(p)));
        }
        if (viewAll) viewAll.href = `${routes.search}?type=product&q=${encodeURIComponent(q)}`;
      }, 280);
      drawerInput.addEventListener('input', () => debouncedSearch(drawerInput.value.trim()));
    }
  }

  /* ══════════════════════════════════════════════════════
     CART DRAWER
     ══════════════════════════════════════════════════════ */
  function initCart() {
    const cartType = cfg.cartType || 'drawer';
    const overlay  = $('hh-cart-overlay');
    const drawer   = $('hh-cart-drawer');
    if (!drawer) return;

    function openCart() {
      if (cartType === 'page') {
        window.location.href = routes.cart;
        return;
      }
      drawer.classList.add('hh-cart-drawer--open');
      if (overlay) overlay.classList.add('hh-overlay--open');
      drawer.removeAttribute('aria-hidden');
      if (overlay) overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('hh-cart-drawer--open');
      if (overlay) overlay.classList.remove('hh-overlay--open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Wire up all cart open buttons (desktop + mobile)
    document.querySelectorAll('.hh-cart-btn').forEach(btn => {
      btn.addEventListener('click', openCart);
    });

    const closeBtn = $('hh-cart-close');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay)  overlay.addEventListener('click', closeCart);

    // Bind qty and remove events inside cart body
    bindCartBodyEvents();
  }

  function bindCartBodyEvents() {
    // Prefer the items-only wrapper (preserves shipping bar on re-render).
    // Fall back to hh-cart-body if the liquid hasn't been updated yet.
    const body = $('hh-cart-items') || $('hh-cart-body');
    if (!body) return;

    body.addEventListener('click', async (e) => {
      const minusBtn = e.target.closest('.hh-qty__btn--minus');
      const plusBtn  = e.target.closest('.hh-qty__btn--plus');
      const removeBtn = e.target.closest('.hh-cart-item__remove');

      if (!minusBtn && !plusBtn && !removeBtn) return;

      const cartItem = e.target.closest('.hh-cart-item');
      if (!cartItem) return;
      const key = cartItem.dataset.key;

      if (removeBtn) {
        // Animate out then remove
        cartItem.style.opacity = '0';
        cartItem.style.maxHeight = cartItem.offsetHeight + 'px';
        cartItem.style.overflow  = 'hidden';
        requestAnimationFrame(() => { cartItem.style.maxHeight = '0'; cartItem.style.padding = '0'; });
        setTimeout(async () => {
          await cartChange(key, 0);
          await refreshCart();
        }, 320);
        return;
      }

      const numEl = cartItem.querySelector('.hh-qty__num');
      if (!numEl) return;
      let qty = parseInt(numEl.textContent, 10);
      if (minusBtn) qty = Math.max(0, qty - 1);
      if (plusBtn)  qty = qty + 1;
      await cartChange(key, qty);
      await refreshCart();
    });
  }

  async function cartChange(key, quantity) {
    try {
      await fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
    } catch (e) { console.error('Cart update failed', e); }
  }

  async function refreshCart() {
    try {
      const r    = await fetch(routes.cartGet);
      const cart = await r.json();
      renderCartDrawer(cart);
      updateCartBadge(cart.item_count);
    } catch (e) { console.error('Cart refresh failed', e); }
  }

  /* ══════════════════════════════════════════════════════
     FREE SHIPPING BAR
     ══════════════════════════════════════════════════════ */

  function getShippingConfig() {
    const shipping = cfg.shipping || {};
    const base     = shipping.baseThreshold || 5000; // pence in store base currency
    const label    = shipping.label || 'free shipping';

    // Shopify injects window.Shopify.currency.rate = exchange rate from base currency
    // e.g. if store is GBP and visitor is in USD, rate ≈ 1.27
    const rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;

    return {
      threshold: Math.round(base * rate),
      label
    };
  }

  function updateShippingBar(cartTotal) {
    const bar      = $('hh-shipping-bar');
    const msgEl    = $('hh-shipping-msg');
    const fillEl   = $('hh-shipping-fill');
    const remEl    = $('hh-shipping-remaining');
    if (!bar || !msgEl || !fillEl) return;

    const sc = getShippingConfig();
    if (!sc || sc.threshold === 0) { bar.style.display = 'none'; return; }
    bar.style.display = '';

    const symbol    = (cfg.currency && cfg.currency.symbol) || '£';
    const threshold = sc.threshold;
    const label     = sc.label || 'free shipping';

    // Use presentment price when multi-currency is active
    const total = cartTotal;

    if (total >= threshold) {
      fillEl.style.width = '100%';
      fillEl.classList.add('hh-shipping-bar__fill--reached');
      msgEl.className = 'hh-shipping-bar__msg hh-shipping-bar__msg--reached';
      msgEl.innerHTML = `You've qualified for <strong>${label}</strong>! 🎉`;
    } else {
      const remaining = threshold - total;
      const pct       = Math.min(100, Math.round((total / threshold) * 100));
      fillEl.style.width = pct + '%';
      fillEl.classList.remove('hh-shipping-bar__fill--reached');
      msgEl.className = 'hh-shipping-bar__msg';
      msgEl.innerHTML = `Spend <strong>${symbol}${(remaining / 100).toFixed(2)}</strong> more for ${label}`;
    }
  }

  function renderCartDrawer(cart) {
    // Target only the items wrapper — shipping bar lives alongside it in hh-cart-body
    // and must NOT be overwritten by item re-renders.
    // Fall back to hh-cart-body if the liquid hasn't been updated yet.
    const items       = $('hh-cart-items') || $('hh-cart-body');
    const drawerCount = $('hh-cart-drawer-count');
    const totalEl     = $('hh-cart-total');
    if (!items) return;

    if (drawerCount) drawerCount.textContent = cart.item_count;

    // Use presentment_total_price for multi-currency stores, fall back to total_price
    const displayTotal = cart.presentment_total_price != null
      ? cart.presentment_total_price
      : cart.total_price;

    if (totalEl) totalEl.textContent = formatMoney(displayTotal);
    updateShippingBar(displayTotal);
    syncCheckoutBtn(cart.item_count);

    // Show/hide the footer meta block (order notes, subtotal, T&C).
    // This section is rendered conditionally by Liquid on page load, but we
    // also need to toggle it after AJAX cart changes (e.g. last item removed).
    const footMeta = $('hh-cart-foot-meta');
    if (footMeta) footMeta.hidden = cart.item_count === 0;

    if (cart.item_count === 0) {
      items.innerHTML = '<p class="hh-cart-drawer__empty">Your bag is empty</p>';
      return;
    }

    items.innerHTML = cart.items.map(item => {
      const price   = formatMoney(item.final_line_price);
      const imgHtml = item.image
        ? `<img src="${item.image}" alt="${item.title}" class="hh-cart-item__img" loading="lazy">`
        : '<div class="hh-cart-item__img-placeholder"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="hh-cart-item__variant">${item.variant_title}</p>` : '';
      const sku = item.sku ? `<p class="hh-cart-item__sku">SKU: ${item.sku}</p>` : '';

      return `
        <div class="hh-cart-item" data-key="${item.key}">
          <a href="${item.url}" class="hh-cart-item__img-wrap">${imgHtml}</a>
          <div class="hh-cart-item__info">
            <div>
              <a href="${item.url}" class="hh-cart-item__name">${item.product_title}</a>
              ${variant}${sku}
            </div>
            <div class="hh-cart-item__bottom">
              <div class="hh-cart-item__actions">
                <div class="hh-qty">
                  <button class="hh-qty__btn hh-qty__btn--minus" data-key="${item.key}" aria-label="Decrease quantity">−</button>
                  <span class="hh-qty__num">${item.quantity}</span>
                  <button class="hh-qty__btn hh-qty__btn--plus" data-key="${item.key}" aria-label="Increase quantity">+</button>
                </div>
                <button class="hh-cart-item__remove" data-key="${item.key}">Remove</button>
              </div>
              <span class="hh-cart-item__price">${price}</span>
            </div>
          </div>
        </div>`;
    }).join('');
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.hh-cart-badge').forEach(el => {
      const prev = parseInt(el.textContent, 10) || 0;
      el.textContent = count;
      el.hidden = count === 0;
      // Trigger pop animation only when count increases
      if (count > prev && count > 0) {
        el.classList.remove('hh-cart-badge--pop');
        void el.offsetWidth; // force reflow so animation restarts
        el.classList.add('hh-cart-badge--pop');
      }
    });
  }

  /* ══════════════════════════════════════════════════════
     WISHLIST (localStorage)
     ══════════════════════════════════════════════════════ */
  const WL_KEY = 'hh_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
  }

  function renderWishlistModal() {
    const itemsEl = $('hh-wl-items');
    const countEl = $('hh-wl-count');
    if (!itemsEl) return;

    const items = getWishlist();
    if (countEl) countEl.textContent = `${items.length} ${items.length === 1 ? 'item' : 'items'}`;

    if (items.length === 0) {
      itemsEl.innerHTML = '<p class="hh-wl__empty">Your wishlist is empty</p>';
      return;
    }

    itemsEl.innerHTML = items.map(product => `
      <div class="hh-wl__item" data-id="${product.id}">
        ${product.image ? `<img src="${product.image}" alt="${product.title}" class="hh-wl__img">` : '<div class="hh-wl__img"></div>'}
        <div class="hh-wl__info">
          <a href="${product.url}" class="hh-wl__name">${product.title}</a>
          ${product.price ? `<span class="hh-wl__price">${formatMoney(product.price)}</span>` : ''}
        </div>
        <button class="hh-wl__remove" data-id="${product.id}" aria-label="Remove from wishlist">×</button>
      </div>
    `).join('');

    itemsEl.querySelectorAll('.hh-wl__remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.id, 10);
        const list = getWishlist().filter(p => p.id !== id);
        try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {}
        renderWishlistModal();
      });
    });
  }

  /* Expose addToWishlist globally so product pages can call it */
  window.hhAddToWishlist = function (product) {
    const list = getWishlist().filter(p => p.id !== product.id);
    list.unshift(product);
    try { localStorage.setItem(WL_KEY, JSON.stringify(list.slice(0, 20))); } catch (e) {}
    renderWishlistModal();
  };

  /* ══════════════════════════════════════════════════════
     SCROLL-HIDE HEADER
     Hides the header when scrolling down, reveals it when
     scrolling back up.  Only active when the header is
     position:sticky (i.e. the sticky setting is on).
     ══════════════════════════════════════════════════════ */
  function initScrollHide() {
    const section = document.querySelector('.hh-header-section');
    if (!section) return;

    // If sticky is disabled via the theme setting the liquid injects
    // `position: static`, so there's nothing to hide/reveal.
    if (getComputedStyle(section).position === 'static') return;

    let lastY    = window.scrollY || window.pageYOffset || 0;
    let hidden   = false;
    let ticking  = false;

    function hide() {
      if (hidden) return;
      hidden = true;
      section.style.top = '-' + section.offsetHeight + 'px';
    }

    function show() {
      if (!hidden) return;
      hidden = false;
      section.style.top = '0px';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        // pageYOffset / documentElement.scrollTop covers all Shopify scroll containers
        const y    = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
        const diff = y - lastY;

        if (y <= 10) {
          show();
        } else if (diff > 4) {
          hide();
        } else if (diff < 0) {
          show();
        }

        lastY   = y;
        ticking = false;
      });
    }

    // `capture: true` catches scroll events on any scrollable container on the page,
    // not just window — needed for Shopify themes that scroll a div instead of <body>.
    window.addEventListener('scroll',   onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }

  /* ══════════════════════════════════════════════════════
     CHECKOUT BUTTON STATE
     Called both on init and after every AJAX cart refresh
     ══════════════════════════════════════════════════════ */
  function syncCheckoutBtn(itemCount) {
    const checkbox    = $('hh-tc-checkbox');
    const checkoutBtn = $('hh-checkout-btn');
    if (!checkoutBtn) return;

    // Disabled if cart empty OR T&C not checked (when checkbox is present)
    const tcOk    = !checkbox || checkbox.checked;
    const enabled = itemCount > 0 && tcOk;

    checkoutBtn.disabled = !enabled;
    checkoutBtn.classList.toggle('hh-checkout-btn--disabled', !enabled);
  }

  function initTcCheckbox() {
    const checkbox    = $('hh-tc-checkbox');
    const checkoutBtn = $('hh-checkout-btn');

    // Wire up checkout button click navigation
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => {
        if (!checkoutBtn.disabled) {
          window.location.href = checkoutBtn.dataset.checkoutUrl || '/checkout';
        }
      });
    }

    // Gate on T&C when checkbox present
    if (checkbox) {
      checkbox.addEventListener('change', () => {
        fetch(routes.cartGet)
          .then(r => r.json())
          .then(cart => syncCheckoutBtn(cart.item_count))
          .catch(() => {});
      });
    }
  }

  /* ══════════════════════════════════════════════════════
     ORDER NOTES — persist value in sessionStorage so
     it survives AJAX cart refreshes within the session
     ══════════════════════════════════════════════════════ */
  function initOrderNotes() {
    const textarea  = $('hh-order-note');
    const toggle    = $('hh-order-note-toggle');
    const body      = $('hh-order-note-body');
    const wrap      = $('hh-order-notes');
    if (!textarea) return;

    // Restore saved note and auto-open if there is one
    try {
      const saved = sessionStorage.getItem('hh_order_note');
      if (saved) {
        textarea.value = saved;
        // Open the accordion so the saved note is visible
        if (wrap && body && toggle) {
          wrap.classList.add('hh-order-notes--open');
          toggle.setAttribute('aria-expanded', 'true');
          body.removeAttribute('aria-hidden');
        }
      }
    } catch (e) {}

    textarea.addEventListener('input', () => {
      try { sessionStorage.setItem('hh_order_note', textarea.value); } catch (e) {}
    });

    // Toggle accordion open / closed
    if (toggle && wrap && body) {
      toggle.addEventListener('click', () => {
        const isOpen = wrap.classList.toggle('hh-order-notes--open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        body.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen) setTimeout(() => textarea.focus(), 280);
      });
    }
  }

  /* ══════════════════════════════════════════════════════
     CART-ADD INTERCEPTOR
     Impulse 7.x does not fire a reliable document-level
     event when the cart changes, so we intercept the
     network layer directly.  Both fetch (modern) and
     XMLHttpRequest (some apps / older Impulse internals)
     are covered.  A short delay lets the cart server-
     response settle before we re-fetch totals.
     ══════════════════════════════════════════════════════ */
  (function interceptCartAdd() {
    const CART_ADD_RE = /\/cart\/add/;

    // ── fetch interceptor ──
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      const url = typeof args[0] === 'string' ? args[0]
        : (args[0] && typeof args[0].url === 'string') ? args[0].url : '';
      const promise = origFetch.apply(this, args);
      if (CART_ADD_RE.test(url)) {
        promise.then(() => { setTimeout(refreshCart, 200); }).catch(() => {});
      }
      return promise;
    };

    // ── XMLHttpRequest interceptor (older apps / Impulse internals) ──
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_ADD_RE.test(url)) {
        this.addEventListener('load', () => { setTimeout(refreshCart, 200); });
      }
      return origOpen.apply(this, arguments);
    };
  })();

  /* ══════════════════════════════════════════════════════
     ALSO LISTEN FOR THEME EVENTS
     (fired by some Shopify themes / apps in addition
     to the network calls above)
     ══════════════════════════════════════════════════════ */
  document.addEventListener('cart:refresh', refreshCart);
  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('cart:change',  refreshCart);

  /* ══════════════════════════════════════════════════════
     INIT
     ══════════════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', () => {
    console.log('[HH Header] DOM ready, initialising features…');
    initTypewriter();
    initDesktopSearch();
    initMobileSearch();
    initMobileMenuDrawer();
    initCart();
    initTcCheckbox();
    initOrderNotes();
    renderWishlistModal();
    initScrollHide();

    // Fetch cart on load to populate shipping bar with correct initial total
    fetch(routes.cartGet)
      .then(r => r.json())
      .then(cart => {
        const displayTotal = cart.presentment_total_price != null
          ? cart.presentment_total_price
          : cart.total_price;
        updateShippingBar(displayTotal);
      })
      .catch(() => {});
  });

})();